import { MAP_ID_AIRPORT } from "../../../store/MapContentsState";
import Airport from "./Airport";
import Heliport from "./Heliport";

export const AIRFIELD_TYPE_AIRPORT = Airport.NAME;
export const AIRFIELD_TYPE_HELIPORT = Heliport.NAME;

class Airfield {
  static NAME = MAP_ID_AIRPORT;

  typeVisible = {
    [AIRFIELD_TYPE_AIRPORT]: true,
    [AIRFIELD_TYPE_HELIPORT]: true
  }

  constructor(isDark) {
    this.airport = new Airport(isDark);
    this.heliport = new Heliport(isDark);
  }

  async drawLayer(visible) {
    this.visible = visible;
    await this.setVisible(this.visible);
  }

  async setVisible(visible) {
    return new Promise(resolve => {
      const promises = [];
      promises.push(this.airport.drawLayer(visible && this.typeVisible[AIRFIELD_TYPE_AIRPORT]));
      promises.push(this.heliport.drawLayer(visible && this.typeVisible[AIRFIELD_TYPE_HELIPORT]));
      Promise.allSettled(promises).then(() => {
        resolve();
      });
    });
  }

  setVisibleWithType(visible, type) {
    this.typeVisible[type] = visible;
    if (!this.visible) {
      return;
    }
    switch (type) {
      case AIRFIELD_TYPE_AIRPORT:
        this.airport.drawLayer(visible);
        break;
      case AIRFIELD_TYPE_HELIPORT:
        this.heliport.drawLayer(visible);
        break;
      default:
    }
  }

  resetTypeVisible() {
    if (Object.values(this.typeVisible).filter(v => v).length === 0) {
      this.typeVisible[AIRFIELD_TYPE_AIRPORT] = true;
      this.typeVisible[AIRFIELD_TYPE_HELIPORT] = true;
    }
  }

  getLayer() {
    return [this.airport.getLayer(), this.heliport.getLayer()];
  }

  isVisible(type) {
    return this.typeVisible[type];
  }

  changeRoutePointEditing(routePointEditing) {
    [this.airport, this.heliport].forEach(contents => {
      if (contents.changeRoutePointEditing) {
        contents.changeRoutePointEditing(routePointEditing);
      }
    });
  }

  applyMapColor(mapColor, isDark) {
    this.airport.applyMapColor(mapColor, isDark);
    this.heliport.applyMapColor(mapColor, isDark);
  }

  getAirportLabelTarget() {
    return this.airport.getLabelTarget()
  }

  setAirportLabelTarget(labelTarget) {
    return this.airport.setLabelTarget(labelTarget);
  }

  getHeliportContentsVisibleState() {
    return this.heliport.getContentsVisibleState()
  }

  setHeliportContentsVisible(name, visible) {
    return this.heliport.setVisible(visible, name);
  }

  setContentsDispatcher(dispatcher) {
    this.airport.setContentsDispatcher(dispatcher);
    this.heliport.setContentsDispatcher(dispatcher);
  }
}

export default Airfield;